import { render, staticRenderFns } from "./historialCorto.vue?vue&type=template&id=725cb046&scoped=true"
import script from "./historialCorto.vue?vue&type=script&lang=js"
export * from "./historialCorto.vue?vue&type=script&lang=js"
import style0 from "./historialCorto.vue?vue&type=style&index=0&id=725cb046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725cb046",
  null
  
)

export default component.exports